import { Provider } from "components/nationality/NationalityContext";
import { NationalityList } from "components/nationality/NationalityList";

export const Nationalities = () => {
    return (
        <Provider>
            <NationalityList />
        </Provider>
    );
};
